import React from 'react'
import classNames from 'classnames'
import { useI18next } from '@toasttab/shared/src/hooks/useI18next'

interface ToastTipsProps {
  size?: 'small' | 'medium'
}

const ToastTips = ({ size = 'medium' }: ToastTipsProps) => {
  const { t } = useI18next()
  const containerCss = classNames({
    // base tips css from global.css
    'toast-tips': true,
    'absolute justify-center mr-5 top-5 bottom-5 flex basis-8 flex-1 uppercase bg-default text-white border-b-[3px] border-b-solid border-b-toast-orange-500':
      true,
    'left-[25px] text-sm': size == 'medium',
    'left-0 text-xs': size == 'small'
  })

  return <div className={containerCss}>{t('Toast Tips')}</div>
}

export default ToastTips
